//更改用户状态信息
export const userStatus = (state,user) => {
  if (user){
    state.userName = user;
    // state.isLogin = true;
  } else if (user == ""){
    //登出的时候，清空sessionStorage里的东西
    sessionStorage.setItem("userName","");
    sessionStorage.setItem("token","");
    state.userName = "";
    // state.token = "";
    // state.isLogin = false;
  }
}

export default {
	// actione里设置请求失败的提示
	setToast(state,data){
		console.log("show info msg:", data);
		state.toast.type = data.type;
		state.toast.content = data.info;
		state.toast.count = state.toast.count + 1;
	},
	userToken(state,userToken){
		if (userToken) {
			state.token = userToken;
		} else {
			state.token = null;
		}
	}, 
	setAnalysisNum(state,data){
		state.bibliometric.analysisNum=data||0;
	},
	setHeaderInfo(state,data){ 
		// console.log(data)
		state.personalScore=data&&data.personalScore?data.personalScore:''; //个人积分
		state.institutionalScore=data&&data.institutionalScore?data.institutionalScore:''; //机构积分
		state.institutionName=data&&data.institutionName?data.institutionName:'';//机构名称
		state.userName=data&&data.loginName?data.loginName:'' //用户名称
		state.personalEndDate=data&&data.personalEndDate?data.personalEndDate:'';//个人到期日期  
		state.institutionEndDate=data&&data.institutionEndDate?data.institutionEndDate:'';//机构到期日期  
		
	},

}
